export default "__VITE_ASSET__c6037b65__"